
import Unlock from "../../../assets/outline/Unlock.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function UnlockIcon({ className, dataTestid = "UnlockIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Unlock data-testid={dataTestid} className={classes} {...rest} />
  );
}
